import createIcon from '../../createIcon';

/**
 * @component @name VpnKey
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuNjUgMTBDMTEuODMgNy42NyA5LjYxIDYgNyA2QzMuNjkgNiAxIDguNjkgMSAxMkMxIDE1LjMxIDMuNjkgMTggNyAxOEM5LjYxIDE4IDExLjgzIDE2LjMzIDEyLjY1IDE0SDE3VjE4SDIxVjE0SDIzVjEwSDEyLjY1Wk03IDE0QzUuOSAxNCA1IDEzLjEgNSAxMkM1IDEwLjkgNS45IDEwIDcgMTBDOC4xIDEwIDkgMTAuOSA5IDEyQzkgMTMuMSA4LjEgMTQgNyAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VpnKey = createIcon('VpnKey', [
  [
    'path',
    {
      d: 'M12.65 10C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H17V18H21V14H23V10H12.65ZM7 14C5.9 14 5 13.1 5 12C5 10.9 5.9 10 7 10C8.1 10 9 10.9 9 12C9 13.1 8.1 14 7 14Z',
      key: '18ofty',
    },
  ],
]);

export default VpnKey;
